export const FIVE_HUNDRED = 'fivehundred'

export const FOUR_OH_FOUR = 'fourohfour'

export const FIVE_OH_THREE = 'fiveohthree'
